import config from "@/utils/config";

// todo - 代码中未用到
// 只留姓名最后一个字
export function hiddenName (name) {
  if (name) {
    let names = name.replace(/\s/g, "")
    return new Array(names.length).join('*') + name.substr(-1)
  }
}

export function imgPath (url) {
  if (url) {
    return url.indexOf("http") >= 0 ? url : config.imgHost + url;
  }
  return url;
}